// scripts.js

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// Initialize Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

jQuery(function ($) {
    Components.init();
    Plugins.init();
});

// Custom video handler
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-handler').forEach(videoCont => {
        const videoType = videoCont.closest('.item-col').dataset.videoType;

        videoCont.addEventListener('click', () => {
            handleClick(videoType, videoCont);
        });
    });
});

function handleClick(videoType, videoCont) {
    fadeOutElements(videoCont);

    if (videoType === 'mp4') {
        const videoElement = videoCont.querySelector('.video-element');
        if (videoElement) {
            videoElement.play();
        }
    } else if (videoType === 'youtube') {
        const videoContainer = videoCont.querySelector('.video-container');
        if (videoContainer) {
            const iframe = videoContainer.querySelector('iframe');
            if (iframe) {
                const src = iframe.src;
                iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
            }
        }
    }
}

function fadeOutElements(videoCont) {
    const playBtnCont = videoCont.querySelector('.play-btn-cont');
    const placeholderImage = videoCont.querySelector('.placeholder-image');
    
    if (playBtnCont) {
        playBtnCont.classList.add('fade-out');
    }
    
    if (placeholderImage) {
        placeholderImage.classList.add('fade-out');
    }
}

// Initialise new Lib
const lib = {
    qsa: (selector, context = document) => context.querySelectorAll(selector),
}


// when document is ready
// slick initialisation for showblog block
jQuery(function ($) {
    $('.showblog').each(function () {
        let carousel = $(this).find('.--customCarousel .carousel-inner');
        let prevArrow = $(this).find('.arrows .arrow-prev');
        let nextArrow = $(this).find('.arrows .arrow-next');
        const Clss = {
            'arrow-disabled' : 'opacity-50 pointer-events-none'
        }

        carousel.slick({
            adaptiveHeight: true,
            dots: false,
            infinite: false,
            slidesToShow: 3,
            mobileFirst: true,
            variableWidth: true,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
        });

        const updateArrowStatus = () => {
            prevArrow.toggleClass(
                Clss['arrow-disabled'], carousel.slick('slickCurrentSlide') === 0
            );
            
            nextArrow.toggleClass(
                Clss['arrow-disabled'], carousel.slick('slickCurrentSlide') >= carousel.slick('getSlick').slideCount - carousel.slick('getSlick').options.slidesToShow
            );
        }

        updateArrowStatus();
        carousel.on('afterChange', updateArrowStatus);
    });
});


// If link is self
document.addEventListener("DOMContentLoaded", function() {
    function normalizeUrl(url) {
        let parser = document.createElement('a');
        parser.href = url;
        return parser.protocol + "//" + parser.host + parser.pathname.replace(/\/$/, ''); // Remove trailing slash
    }

    const currentUrl = window.location.href;
    
    const links = document.querySelectorAll('a');

    // Iterate through each link
    links.forEach(link => {
        const linkUrl = link.href;

        if(linkUrl.includes('mailto:') || linkUrl.includes('tel:')) return;
        if(linkUrl.includes('#') || linkUrl.includes('?')) return;

        // Compare the normalized link's href with the current page URL
        if (normalizeUrl(linkUrl) === normalizeUrl(currentUrl)) {
            // If they match, add 'pointer-events: none'
            link.style.pointerEvents = 'none';
            link.classList.add('disabled-link'); // Optional: add a class to style the link

            if(linkUrl.includes('contact')) {
                link.style.opacity = '0.5'; // Optional: add a class to style the link
            }
        }
    });
});

// Change background colour of form fields if someone has filled them out 
document.addEventListener("DOMContentLoaded", function() {
  // Select all input, select, and textarea elements inside .form001
  const inputs = document.querySelectorAll(".form001 input, .form001 select, .form001 textarea");

  inputs.forEach(input => {
    // Add or remove the 'filled' class based on input value
    input.addEventListener("input", function() {
      if (input.value.trim() !== "") {
        input.classList.add("filled");
      } else {
        input.classList.remove("filled");
      }
    });

    // Initial check to see if inputs are pre-filled
    if (input.value.trim() !== "") {
      input.classList.add("filled");
    }
  });
});